import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const spApi = axios.create({ baseURL: `${BASE}/api` });

spApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pd_sp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function spErrorMessage(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";
}

export function setSpToken(t) {
  if (t) localStorage.setItem("pd_sp_token", t);
  else localStorage.removeItem("pd_sp_token");
}

export function getSpToken() {
  return localStorage.getItem("pd_sp_token");
}

export default spApi;
